import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["mortgageRenewalDate"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat-map";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { getField } from "@joandvgv/vuex-map-fields";
import { MORTGAGE_TYPE_PARSER } from "@Shared/js/constants";
import { getFullNameWithSalutationFrom, removeEmptyKeys, validateApplicationPath } from "@Shared/utils/utils";
import { camelCase, cloneDeep, difference, get, isEmpty, mapKeys, map, maxBy, filter, sortBy, invert } from "lodash";
export const GET_CLIENT_INFORMATION_FOR_TRANSFER = "GET_CLIENT_INFORMATION_FOR_TRANSFER";
export const APPLICATION_CLIENT_DETAILS = "APPLICATION_CLIENT_DETAILS";
export const APPLICATION_CLIENT_FULL_NAME = "APPLICATION_CLIENT_FULL_NAME";
export const GET_LENDER_NAME_BY_MORTGAGE_TYPE = "GET_LENDER_NAME_BY_MORTGAGE_TYPE";
export const AGENT_IS_OWNER = "AGENT_IS_OWNER";
export const ORDERED_FILOGIX_SUBMISSIONS = "ORDERED_FILOGIX_SUBMISSIONS";
export const CURRENT_APPLICATION_APPLICANTS = "CURRENT_APPLICATION_APPLICANTS";
export const CURRENT_APPLICATION_REQUESTED_PACKAGES = "CURRENT_APPLICATION_REQUESTED_PACKAGES";
export const REQUESTED_MORTGAGES = "REQUESTED_MORTGAGES";
export const NOT_REQUESTED_MORTGAGES = "NOT_REQUESTED_MORTGAGES";
export const MORTGAGES_KEYS_WITH_SUBMISSIONS = "MORTGAGES_KEYS_WITH_SUBMISSIONS";
export const MORTGAGES_KEYS_WITHOUT_SUBMISSIONS = "MORTGAGES_KEYS_WITHOUT_SUBMISSIONS";
export const CLIENT_APPLICATION_OWNER_USERNAME = "CLIENT_APPLICATION_OWNER_USERNAME";
export const IS_APPLICATION_SYNCABLE = "IS_APPLICATION_SYNCABLE";
export const APPLICATION_SYNC_STATUS = "APPLICATION_SYNC_STATUS";
export const APPLICATION_STATUS = "APPLICATION_STATUS";
export const ARE_FILOGIX_DETAILS_VERIFIED = "ARE_FILOGIX_DETAILS_VERIFIED";
export const IS_CURRENT_USER_APPLICATION_OWNER = "IS_CURRENT_USER_APPLICATION_OWNER";
export const CURRENT_APPLICATION_LINKED_PROFILES = "CURRENT_APPLICATION_LINKED_PROFILES";
export const CURRENT_APPLICATION_SUB_STATUS = "CURRENT_APPLICATION_SUB_STATUS";
export const IS_SUB_STATUS_PAID = "IS_SUB_STATUS_PAID";
export const GET_SUBMISSION_DETAILS_BY_MORTGAGE_TYPE = "GET_SUBMISSION_DETAILS_BY_MORTGAGE_TYPE";
export const CURRENT_APPLICATION_PRINCIPAL_BORROWER = "CURRENT_APPLICATION_PRINCIPAL_BORROWER";
export const CALCULATED_MORTGAGE_VALUES = "CALCULATED_MORTGAGE_VALUES";
export const CALCULATED_VALUES_BY_MORTGAGE_TYPE = "CALCULATED_VALUES_BY_MORTGAGE_TYPE";
export const CURRENT_TOTAL_LOAN_AMOUNT = "CURRENT_TOTAL_LOAN_AMOUNT";
export const GET_LATEST_LENDER_SUBMISSION = "GET_LATEST_LENDER_SUBMISSION";
export const CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES = "CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES";
export const GET_APPLICATION_REFERRAL_SOURCE = "GET_APPLICATION_REFERRAL_SOURCE";
export const MORTGAGE_AMOUNT = "MORTGAGE_AMOUNT";
export const LENDERS = "LENDERS";
export const OTHER_PROPERTIES_BY_APPLICANT = "OTHER_PROPERTIES_BY_APPLICANT";
export const CURRENT_APPLICATION_ID = "CURRENT_APPLICATION_ID";
export const CURRENT_APPLICATION = "CURRENT_APPLICATION";
export const REQUESTED_MORTGAGES_DETAILS = "REQUESTED_MORTGAGES_DETAILS";
export const CO_BROKERED_MORTGAGES = "CO_BROKERED_MORTGAGES";
export const fieldIsVisible = "fieldIsVisible";
export const fieldIsRequired = "fieldIsRequired";
export const INSURANCE_SUBMISSIONS_HISTORY = "INSURANCE_SUBMISSIONS_HISTORY";
export const GET_INSURANCE_PROVIDERS = "GET_INSURANCE_PROVIDERS";
export default {
  currentFlow: state => state.currentFlow,
  getField,
  getDetails: (state, getters) => path => {
    const currentApplication = getters[CURRENT_APPLICATION];
    const application = get(currentApplication, path);
    return getField(mapKeys(application, (v, k) => camelCase(k)));
  },
  getManualResponseDetails: state => path => {
    const manualResponse = get(state, path);
    return getField(mapKeys(manualResponse, (v, k) => k));
  },
  getManualSubmissionMortgage: state => {
    var _state$submissionManu;
    const currentSubmissionId = state.currentManualResponseId;
    return getField((_state$submissionManu = state.submissionManualResponse.byId[currentSubmissionId]) == null ? void 0 : _state$submissionManu.mortgage);
  },
  getManualSubmissionDeal: state => {
    var _state$submissionManu2;
    const currentSubmissionId = state.currentManualResponseId;
    return getField((_state$submissionManu2 = state.submissionManualResponse.byId[currentSubmissionId]) == null ? void 0 : _state$submissionManu2.deal);
  },
  getManualSubmissionResponse: state => {
    var _state$submissionManu3;
    const currentSubmissionId = state.currentManualResponseId;
    return getField((_state$submissionManu3 = state.submissionManualResponse.byId[currentSubmissionId]) == null ? void 0 : _state$submissionManu3.response);
  },
  allOtherProperties: (state, getters) => {
    var _context, _context2;
    const currentApplication = getters[CURRENT_APPLICATION];
    const allProperties = [];
    const applicationInfo = cloneDeep(currentApplication);
    const otherPropertiesRef = cloneDeep(state.emptyApplication[currentApplication.flow]);
    if (isEmpty(otherPropertiesRef) || isEmpty(applicationInfo)) {
      return allProperties;
    }
    const {
      "co-applicants": coapps,
      "main-applicant": mainApp
    } = applicationInfo;
    const mainAppProperties = _filterInstanceProperty(_context = _mapInstanceProperty(_context2 = mainApp["other-properties"]).call(_context2, (property, propertyIndex) => {
      const {
        line1
      } = property["property-details"].address || {};
      const downPayments = applicationInfo["mortgage-details"]["down-payment"];
      const {
        amount
      } = downPayments && _findInstanceProperty(downPayments).call(downPayments, downpayment => downpayment && downpayment.description === line1 && line1) || {};
      if (isEmpty(removeEmptyKeys(property)) && propertyIndex === 0) {
        return {};
      }
      return _objectSpread(_objectSpread({}, property), {}, {
        order: property.order != null ? property.order : propertyIndex,
        ["property-equity"]: amount || property["property-equity"] || null,
        applicantIndex: 0,
        propertyIndex
      });
    })).call(_context, item => !isEmpty(item));
    allProperties.push(...mainAppProperties);
    coapps.forEach((coapp, index) => {
      const coappOtherProperties = coapp["other-properties"];
      coappOtherProperties.forEach((property, propertyIndex) => {
        const {
          line1
        } = property["property-details"].address || {};
        const downPayments = applicationInfo["mortgage-details"]["down-payment"];
        const {
          amount
        } = downPayments && _findInstanceProperty(downPayments).call(downPayments, downpayment => downpayment && downpayment.description === line1 && line1) || {};
        if (isEmpty(removeEmptyKeys(property)) && propertyIndex === 0) {
          return;
        }
        allProperties.push(_objectSpread(_objectSpread({}, property), {}, {
          order: property.order != null ? property.order : allProperties.length,
          ["property-equity"]: amount || property["property-equity"] || null,
          applicantIndex: index + 1,
          propertyIndex
        }));
      });
    });
    return sortBy(allProperties, [property => property.order]);
  },
  fieldIsVisible: (state, getters) => ({
    paths
  }) => {
    var _schema$processedPath, _schema$processedPath2;
    if (!paths.length) return true;
    const currentApplication = getters[CURRENT_APPLICATION];
    const flow = currentApplication.flow;
    const schema = state.customizationSchema;
    if (isEmpty(schema) || !flow) return;
    const [mainPath] = paths;
    const processedPath = validateApplicationPath(mainPath);
    return (_schema$processedPath = (_schema$processedPath2 = schema[processedPath].visible) == null ? void 0 : _schema$processedPath2[flow]) != null ? _schema$processedPath : false;
  },
  fieldIsRequired: (state, getters) => ({
    paths
  }) => {
    var _schema$processedPath3, _schema$processedPath4;
    if (!paths.length) return true;
    const currentApplication = getters[CURRENT_APPLICATION];
    const flow = currentApplication.flow;
    const schema = state.customizationSchema;
    if (isEmpty(schema) || !flow) return;
    const [mainPath] = paths;
    const processedPath = validateApplicationPath(mainPath);
    return (_schema$processedPath3 = (_schema$processedPath4 = schema[processedPath].required) == null ? void 0 : _schema$processedPath4[flow]) != null ? _schema$processedPath3 : false;
  },
  [GET_CLIENT_INFORMATION_FOR_TRANSFER]: state => ({
    applicationId,
    clientUsername
  }) => {
    var _application$mainApp;
    const client = state.clients[clientUsername];
    const {
      givenName,
      familyName,
      email,
      phoneNumber
    } = client;
    const _state$applications$b = state.applications.byId[applicationId],
      {
        mortgageRenewalDate = null
      } = _state$applications$b,
      application = _objectWithoutProperties(_state$applications$b, _excluded);
    const dateOfBirth = (application == null ? void 0 : (_application$mainApp = application["main-applicant"]) == null ? void 0 : _application$mainApp["personal-details"]["date-of-birth"]) || null;
    return {
      clientUsername,
      givenName,
      familyName,
      email,
      ownerUsername: "",
      // this is filled by the caller, since (for some reason) we don't store agentUsername in vuex
      applicationId,
      phoneNumber,
      mortgageRenewalDate,
      dateOfBirth
    };
  },
  [APPLICATION_CLIENT_DETAILS]: state => clientUsername => {
    return state.clients[clientUsername];
  },
  [APPLICATION_CLIENT_FULL_NAME]: (state, getters) => clientUsername => {
    const {
      givenName = "",
      familyName = ""
    } = getters.APPLICATION_CLIENT_DETAILS(clientUsername);
    return [givenName, familyName].join(" ");
  },
  [GET_LENDER_NAME_BY_MORTGAGE_TYPE]: state => ({
    mortgageType,
    applicationId
  }) => {
    var _state$applications$b2;
    const details = (_state$applications$b2 = state.applications.byId[applicationId]) == null ? void 0 : _state$applications$b2["submission-details"];
    if (isEmpty(details)) return "";
    const submission = _findInstanceProperty(details).call(details, detail => detail["submission-details"]["mortgage-type"] === mortgageType);
    return submission["submission-details"]["lender"];
  },
  [AGENT_IS_OWNER]: (state, getters, rootState) => agentUsername => {
    return rootState.AccountStore.userDetails.username === agentUsername;
  },
  [ORDERED_FILOGIX_SUBMISSIONS]: state => applicationId => {
    var _context3, _state$filogix$submis;
    return _sortInstanceProperty(_context3 = _Object$values(((_state$filogix$submis = state.filogix.submissions.byApplication[applicationId]) == null ? void 0 : _state$filogix$submis.byId) || {})).call(_context3, (a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  },
  /**
   * Return a list of all applicants in the application
   * Will ignore what ever is in the coApplicants array if the flag
   * coapp is false
   *
   */
  [CURRENT_APPLICATION_APPLICANTS]: (state, getters) => {
    var _context4, _context5;
    const currentApplication = getters[CURRENT_APPLICATION];
    const {
      "main-applicant": mainApplicant = {},
      "co-applicants": coApplicants = []
    } = currentApplication || {};
    const {
      coapp = false
    } = (mainApplicant == null ? void 0 : mainApplicant["personal-details"]) || {};
    const allCoapplicants = coapp ? coApplicants : [];
    return _mapInstanceProperty(_context4 = _filterInstanceProperty(_context5 = [mainApplicant, ...allCoapplicants]).call(_context5, applicant => !isEmpty(applicant))).call(_context4, (applicant, applicantIndex) => _objectSpread(_objectSpread({}, applicant), {}, {
      applicantIndex
    }));
  },
  [CURRENT_APPLICATION_REQUESTED_PACKAGES]: state => applicationId => {
    return state.requestedPackages.byApplication[applicationId];
  },
  [CURRENT_APPLICATION_HAS_REQUESTED_MORTGAGES]: (state, getters) => {
    var _getters$REQUESTED_MO;
    if (state.calculatedValues.loading) return undefined;
    return (_getters$REQUESTED_MO = getters.REQUESTED_MORTGAGES) == null ? void 0 : _getters$REQUESTED_MO.some(mortgageType => !isEmpty(mortgageType) && getters.MORTGAGE_AMOUNT(mortgageType) !== 0);
  },
  [REQUESTED_MORTGAGES]: (state, getters) => {
    var _currentApplication$m;
    const currentApplication = getters[CURRENT_APPLICATION];
    const mortgages = (_currentApplication$m = currentApplication["mortgage-details"]) == null ? void 0 : _currentApplication$m.mortgages;
    if (isEmpty(mortgages)) return [];
    const submissionDetails = currentApplication["submission-details"];
    if (isEmpty(submissionDetails)) return [];
    return _flatMapInstanceProperty(submissionDetails).call(submissionDetails, ({
      "submission-details": submissionDetails
    }) => {
      var _mortgages$mortgageIn;
      const mortgageType = submissionDetails["mortgage-type"];
      const mortgageIndex = MORTGAGE_TYPE_PARSER[mortgageType];
      return ((_mortgages$mortgageIn = mortgages[mortgageIndex]) == null ? void 0 : _mortgages$mortgageIn.requested) === "requested" ? mortgageType : [];
    });
  },
  [NOT_REQUESTED_MORTGAGES]: (state, getters) => {
    const validMortgageTypes = _Object$keys(MORTGAGE_TYPE_PARSER);
    const requestedMortgages = getters.REQUESTED_MORTGAGES;
    return difference(validMortgageTypes, requestedMortgages);
  },
  [REQUESTED_MORTGAGES_DETAILS]: (state, getters) => {
    var _currentApplication$m2, _currentApplication$m3;
    const currentApplication = getters[CURRENT_APPLICATION];
    const mortgages = (_currentApplication$m2 = (_currentApplication$m3 = currentApplication["mortgage-details"]) == null ? void 0 : _currentApplication$m3.mortgages) != null ? _currentApplication$m2 : [];
    return _reduceInstanceProperty(mortgages).call(mortgages, (mortgagesWithType, mortgage, index) => {
      if (mortgage.requested === "requested") mortgagesWithType.push(_objectSpread(_objectSpread({}, mortgage), {}, {
        type: invert(MORTGAGE_TYPE_PARSER)[index]
      }));
      return mortgagesWithType;
    }, []);
  },
  [CLIENT_APPLICATION_OWNER_USERNAME]: state => ({
    applicationId,
    clientUsername
  }) => {
    var _client$applications;
    const client = state.clients[clientUsername] || {};
    const application = (_client$applications = client.applications) == null ? void 0 : _client$applications.byId[applicationId];
    return (application == null ? void 0 : application.agentUsername) || "";
  },
  [IS_APPLICATION_SYNCABLE]: state => applicationId => {
    return !!state.applications.byId[applicationId].syncable;
  },
  [APPLICATION_SYNC_STATUS]: state => applicationId => {
    var _state$applications$b3;
    return ((_state$applications$b3 = state.applications.byId[applicationId]) == null ? void 0 : _state$applications$b3.sync) || {};
  },
  [APPLICATION_STATUS]: (state, getters) => {
    const currentApplication = getters[CURRENT_APPLICATION];
    return currentApplication.applicationStatus;
  },
  [ARE_FILOGIX_DETAILS_VERIFIED]: (state, getters, rootState, rootGetters) => ({
    applicationId,
    clientUsername
  }) => {
    var _state$applications$b4, _state$applications$b5, _state$applications$b6;
    return getters.IS_CURRENT_USER_APPLICATION_OWNER({
      applicationId,
      clientUsername
    }) ? rootGetters["SettingsStore/GET_FILOGIX_DETAILS"].verified : (_state$applications$b4 = (_state$applications$b5 = state.applications.byId[applicationId]) == null ? void 0 : (_state$applications$b6 = _state$applications$b5.appOwnerDetails) == null ? void 0 : _state$applications$b6.verified) != null ? _state$applications$b4 : true;
  },
  [IS_CURRENT_USER_APPLICATION_OWNER]: (state, getters, rootState, rootGetters) => ({
    applicationId,
    clientUsername
  }) => {
    return rootGetters["AccountStore/CURRENT_USER_USERNAME"] === getters.CLIENT_APPLICATION_OWNER_USERNAME({
      applicationId,
      clientUsername
    });
  },
  [CURRENT_APPLICATION_LINKED_PROFILES]: (state, getters) => {
    const currentApplication = getters[CURRENT_APPLICATION];
    return currentApplication.linkedProfiles || [];
  },
  [CURRENT_APPLICATION_SUB_STATUS]: (state, getters) => {
    var _currentApplication$a;
    const currentApplication = getters[CURRENT_APPLICATION];
    return (_currentApplication$a = currentApplication == null ? void 0 : currentApplication.appSubStatus) != null ? _currentApplication$a : "";
  },
  [IS_SUB_STATUS_PAID]: (state, getters) => {
    return getters.CURRENT_APPLICATION_SUB_STATUS === "paid";
  },
  [CURRENT_TOTAL_LOAN_AMOUNT]: state => {
    const {
      mortgageValues
    } = state.calculatedValues;
    if (!mortgageValues || !mortgageValues.length) return;
    return _reduceInstanceProperty(mortgageValues).call(mortgageValues, (acc, {
      totalLoanAmount
    }) => {
      acc += totalLoanAmount;
      return acc;
    }, 0);
  },
  [CALCULATED_MORTGAGE_VALUES]: state => {
    return state.calculatedValues.mortgageValues;
  },
  [CALCULATED_VALUES_BY_MORTGAGE_TYPE]: (state, getters) => mortgageType => {
    var _context6, _getters$CALCULATED_M;
    return _findInstanceProperty(_context6 = (_getters$CALCULATED_M = getters[CALCULATED_MORTGAGE_VALUES]) != null ? _getters$CALCULATED_M : []).call(_context6, mortgage => mortgage.mortgageType === mortgageType) || {};
  },
  [MORTGAGE_AMOUNT]: (state, getters) => mortgageType => {
    const calculatedDetails = getters.CALCULATED_VALUES_BY_MORTGAGE_TYPE(mortgageType);
    return (calculatedDetails == null ? void 0 : calculatedDetails.totalLoanAmount) || 0;
  },
  [CURRENT_APPLICATION_PRINCIPAL_BORROWER]: (state, getters) => {
    const currentApplication = getters[CURRENT_APPLICATION];
    const applicant = currentApplication["main-applicant"]["personal-details"];
    return getFullNameWithSalutationFrom(applicant);
  },
  [GET_SUBMISSION_DETAILS_BY_MORTGAGE_TYPE]: (state, getters) => mortgageType => {
    const validMortgageTypes = _Object$keys(MORTGAGE_TYPE_PARSER);
    if (!_includesInstanceProperty(validMortgageTypes).call(validMortgageTypes, mortgageType)) return {};
    const currentApplication = getters[CURRENT_APPLICATION];
    const submissionDetails = currentApplication["submission-details"];
    if (isEmpty(submissionDetails)) return [];
    return _findInstanceProperty(submissionDetails).call(submissionDetails, submission => submission["submission-details"]["mortgage-type"] === mortgageType) || {};
  },
  [GET_LATEST_LENDER_SUBMISSION]: state => mortgageType => {
    const allLenderSubmissions = filter(state.submissionHistory.byId, submission => submission.mortgageType === mortgageType);
    if (isEmpty(allLenderSubmissions)) return {};
    const acceptedSubmissions = filter(allLenderSubmissions, submission => submission.status === "accepted");
    const submissionsToUse = acceptedSubmissions.length ? acceptedSubmissions : allLenderSubmissions;
    return maxBy(submissionsToUse, submission => submission.createdAt);
  },
  [MORTGAGES_KEYS_WITH_SUBMISSIONS]: state => {
    return map(state.submissionHistory.byId, submission => submission.mortgageType);
  },
  [MORTGAGES_KEYS_WITHOUT_SUBMISSIONS]: (state, getters) => {
    const validMortgageTypes = _Object$keys(MORTGAGE_TYPE_PARSER);
    const mortgagesWithSubmissions = getters.MORTGAGES_KEYS_WITH_SUBMISSIONS;
    return difference(validMortgageTypes, mortgagesWithSubmissions);
  },
  [GET_APPLICATION_REFERRAL_SOURCE]: (state, getters) => {
    var _currentApplication$r;
    const currentApplication = getters[CURRENT_APPLICATION];
    return (_currentApplication$r = currentApplication == null ? void 0 : currentApplication.referrerId) != null ? _currentApplication$r : null;
  },
  [LENDERS]: state => {
    var _context7;
    return _mapInstanceProperty(_context7 = state.lenders).call(_context7, ({
      label,
      value,
      mtgProductId,
      submitCreditReports
    }) => ({
      label,
      value,
      mtgProductId,
      submitCreditReports
    }));
  },
  [OTHER_PROPERTIES_BY_APPLICANT]: (state, getters) => applicantIndex => {
    let allProperties = [];
    const currentApplication = getters[CURRENT_APPLICATION];
    const applicationInfo = cloneDeep(currentApplication);
    const {
      "co-applicants": coapps,
      "main-applicant": mainApp
    } = applicationInfo;
    if (applicantIndex === 0) {
      var _context8, _context9;
      const otherPropertiesRef = cloneDeep(state.emptyApplication[currentApplication.flow]);
      if (isEmpty(otherPropertiesRef) || isEmpty(applicationInfo)) {
        return allProperties;
      }
      const mainAppProperties = _filterInstanceProperty(_context8 = _mapInstanceProperty(_context9 = mainApp["other-properties"]).call(_context9, (property, propertyIndex) => {
        const {
          line1
        } = property["property-details"].address || {};
        const downPayments = applicationInfo["mortgage-details"]["down-payment"];
        const {
          amount
        } = downPayments && _findInstanceProperty(downPayments).call(downPayments, downpayment => downpayment && downpayment.description === line1 && line1) || {};
        if (isEmpty(removeEmptyKeys(property)) && propertyIndex === 0) {
          return {};
        }
        return _objectSpread(_objectSpread({}, property), {}, {
          order: property.order != null ? property.order : propertyIndex,
          ["property-equity"]: amount || property["property-equity"] || null,
          applicantIndex: 0,
          propertyIndex
        });
      })).call(_context8, item => !isEmpty(item));
      allProperties.push(...mainAppProperties);
    } else {
      const coapp = coapps[applicantIndex - 1];
      const coappOtherProperties = coapp["other-properties"];
      coappOtherProperties.forEach((property, propertyIndex) => {
        const {
          line1
        } = property["property-details"].address || {};
        const downPayments = applicationInfo["mortgage-details"]["down-payment"];
        const {
          amount
        } = downPayments && _findInstanceProperty(downPayments).call(downPayments, downpayment => downpayment && downpayment.description === line1 && line1) || {};
        if (isEmpty(removeEmptyKeys(property)) && propertyIndex === 0) {
          return;
        }
        allProperties.push(_objectSpread(_objectSpread({}, property), {}, {
          order: property.order != null ? property.order : allProperties.length,
          ["property-equity"]: amount || property["property-equity"] || null,
          applicantIndex,
          propertyIndex
        }));
      });
    }
    return sortBy(allProperties, [property => property.order]);
  },
  [CURRENT_APPLICATION_ID]: state => {
    return state.currentApplicationId;
  },
  [CURRENT_APPLICATION]: (state, getters) => {
    const currentApplicationId = getters[CURRENT_APPLICATION_ID];
    const currentApplication = state.applications.byId[currentApplicationId];
    if (isEmpty(currentApplication)) return {};
    return currentApplication;
  },
  [CO_BROKERED_MORTGAGES]: (_, getters) => {
    var _getters$CURRENT_APPL;
    return (_getters$CURRENT_APPL = getters[CURRENT_APPLICATION].cobrokeredMortgages) != null ? _getters$CURRENT_APPL : null;
  },
  [INSURANCE_SUBMISSIONS_HISTORY]: state => {
    return state.insuranceSubmissionsHistory;
  },
  [GET_INSURANCE_PROVIDERS]: state => {
    return state.insuranceProviders;
  }
};